import { Flex, StackProps, TextProps } from "@chakra-ui/react";
import CDS from "design-system";
import { isValidElement } from "react";
import { CopyableValue } from "./Copyable";

interface FieldRowProps extends StackProps {
  fieldName: string;
  displayValue: string | JSX.Element;
  copyableValue?: string;
  headerProps?: TextProps;
}

export default function FieldRow({
  fieldName,
  displayValue,
  copyableValue = undefined,
  headerProps = {},
  ...rest
}: FieldRowProps) {
  if (copyableValue && isValidElement(displayValue)) {
    console.error("copyableValue is true and displayValue is not a string");
  }
  return (
    <Flex width="100%" direction="column" spacing="0.5" fontSize="sm" {...rest}>
      <CDS.Text12 color="fg.emphasized" fontWeight="medium" {...headerProps}>
        {fieldName}
      </CDS.Text12>
      {copyableValue ? (
        <CopyableValue displayValue={displayValue as string} copyableValue={copyableValue} />
      ) : isValidElement(displayValue) ? (
        displayValue
      ) : (
        <CDS.Text12 color="fg.muted">{displayValue}</CDS.Text12>
      )}
    </Flex>
  );
}
